import { connect } from 'react-redux';
import RoomLiveWrapper from "../components/general/RoomLiveWrapper";

const mapStateToProps = state => {
    return {
       
    };
};

const mapDispatchToProps = dispatch => {
    return {
        
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoomLiveWrapper);


// WEBPACK FOOTER //
// ./src/containers/RoomLive.js